import { fetchRegionData } from '@/services/api.index'

export const getRegionTreeData = async () => {
  const { data: { city, county, province } } = await fetchRegionData()
  const cityHashMap = city.reduce((pre, { code }, index) => pre.set(code.slice(0, 4), index), new Map())
  const provinceHashMap = province.reduce((pre, { code }, index) => pre.set(code.slice(0, 2), index), new Map())
  county.forEach(({ code, name }) => {
    // 对重庆进行特殊处理
    const sameCode = code.slice(0, 4) === '5002' ? '5001' : code.slice(0, 4)
    const parentEl = city[cityHashMap.get(sameCode)]
    parentEl.children = [...(parentEl.children || []), { label: name, value: code }]
  })
  city.forEach(({ code, name, children }) => {
    const parentEl = province[provinceHashMap.get(code.slice(0, 2))]
    parentEl.children = [...(parentEl.children || []), { label: name, value: code, children }]
  })
  return province.map(({ name, code, children }) => ({ label: name, value: code, children }))
}


// WEBPACK FOOTER //
// ./src/utils/region.js